import {jwtDecode} from "jwt-decode";
import { apiConnector } from "../apiConnector"
import { apiClient } from "../apiClient"
import { setLoading, setToken } from "../../slices/authSlice"
import { setUser } from "../../slices/profileSlice"
import { setusers } from "../../slices/users";
import {setdevices} from '../../slices/devices'
import { toast } from "react-hot-toast"

//ORGANIZATION API CALLING FUNCTION LOGIC.
export function profile(token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", apiClient.PROFILE_DATA, null, {
                Authorization: `Bearer ${token}`
            })

            if(!response.data.success){
                throw new Error(response.data.message)
            }
            dispatch(setUser(response.data.data))
            localStorage.setItem("user",JSON.stringify(response.data.data))
        } catch (error) {
            console.log("Profile Fetching Updateing Login Error.")
            toast.error(error.message)
        }
    }
}
export function Signup(formData,navigate) {
    console.log("FormData Signup Org:",formData)
    return async (dispatch) => {
        const toastId = toast.loading("Looding....")
        dispatch(setLoading(true))
        try {
            const response = await apiConnector("POST", apiClient.SIGNUP_API, formData)
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            toast.success("SuccessFully Signup..")
        
            navigate('/login')
        } catch (error) {
            const message = error.response?.data?.message || error.message
            console.log("LOGIN API ERROR............", message)
            toast.error(message || "Login Failed")
        }
        dispatch(setLoading(false))
        toast.dismiss(toastId)
    }
}
export function Login(formData,navigate) {
    return async (dispatch) => {
        console.log("Login Calling")
        try {
            console.log("Formdata:",formData)
            const response = await apiConnector("POST", apiClient.LOGIN_API, formData)
             console.log("responseponse:",response)
            if (!response.data.success) {
                throw new Error(response.data.message)
            }
            console.log("responseponse:",response.data)
            toast.success("SuccessFully Login..")
            dispatch(setToken(response.data.data))
            localStorage.setItem("token", response.data.data)
            dispatch(profile(response.data.data))
            navigate('/')
            return response?.data
        } catch (error) {
            const message = error.response?.data?.message||error?.message
            console.log("LOGIN API ERROR:", message)
            return error.response?.data
        }
    }
}
export function OrgChangePassword(payload,token) {
  return async (dispatch) => {
    try {
      const res = await apiConnector('POST', apiClient.CHANGE_PASSWORD_ORG, payload,{
        Authorization:`Bearer ${token}`
      })
      if (!res?.data?.success) {
        throw new Error(res?.data?.message)
      }
      toast.success(res?.data?.message)
      return res
    } catch (error) {
      const message = error?.response?.data?.message
      console.log("Internal Server Error:", error)
      toast.error(message)
      return error?.response
    }
  }
}
export function Logout(navigate){
    return async(dispatch)=>{
        try {
            dispatch(setToken(null))
            dispatch(setUser(null))
            dispatch(setusers([]))
            dispatch(setdevices([]))
            localStorage.removeItem("token")
            localStorage.removeItem("user")
            localStorage.removeItem('users')
            localStorage.removeItem('devices')
            localStorage.removeItem('attendance')
            localStorage.removeItem('managers')
            navigate('/login')
            toast.success("LogOut SuccessFully..")
        } catch (error) {
            console.log("LogOut Function Error:",error.message)
            toast.error("Faild To LogOut")
        }
    }
}

//MANAGER API CALLING FUNCTION LOGIC.
export function Manager_Profile(token) {
    return async (dispatch) => {
        try {
            const response = await apiConnector("GET", apiClient.MANAGER_DETAILS, null, {
                Authorization: `Bearer ${token}`
            })

            if(!response.data.success){
                throw new Error(response.data.message)
            }
            dispatch(setUser(response.data.data))
            localStorage.setItem("user",JSON.stringify(response.data.data))
        } catch (error) {
            console.log("Profile Fetching Updateing Login Error.")
            toast.error(error.message)
        }
    }
}
export function Manager_Login(formData,navigate){
    return async(dispatch)=>{
        try {
            const response = await apiConnector("POST",apiClient.MANAGER_LOGIN,formData)
            if(!response.data.success){
                throw new Error(response.data.message)
            }
            dispatch(setToken(response.data.data))
            localStorage.setItem('token',response.data.data)
            dispatch(Manager_Profile(response.data.data))
            toast.success(response.data.message)
            navigate('/')
            return response?.data
        } catch (error) {
            const message = error.response?.data?.message||error?.message
            console.log("Error In Manager Login:",message)
            return error.response?.data
        }
    }
}
export function ManagerChangePassword(payload,token) {
  return async (dispatch) => {
    try {
      const res = await apiConnector('POST', apiClient.CHANGE_PASSWORD_MANAGER, payload,{
        Authorization:`Bearer ${token}`
      })
      if (!res?.data?.success) {
        throw new Error(res?.data?.message)
      }
      toast.success(res?.data?.message)
      return res
    } catch (error) {
      const message = error?.response?.data?.message
      console.log("Internal Server Error:", error)
      toast.error(message)
      return error?.response
    }
  }
}

export function isTokenExpired(token) {
  try {
    const decoded = jwtDecode(token);
    return decoded.exp * 1000 < Date.now();
  } catch (error) {
    return true; // if token invalid
  }
}